var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m222.2968,187.7033l5.6416-36.7841h-35.2923v-23.87c0-10.0632,4.93-19.8718,20.7375-19.8718h16.046v-31.3159s-14.5627-2.4856-28.4851-2.4856c-29.067,0-48.0645,17.6165-48.0645,49.5087v28.0347h-32.3097v36.7841h32.3097v88.9209h39.7661v-88.9209h29.6506Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBFacebook);
export default __webpack_public_path__ + "static/media/B_Facebook.76b9d6c1bbdda50e2f8ed3eccbf15adc.svg";
export { ForwardRef as ReactComponent };